<div class="grid grid-column grid-gutter-36">
  <div class="grid-item full-width">
    <div class="grid grid-gutter-20">
      <app-shared-promotion
        *ngFor="let promotion of promotionsList; let i = index"
        [promotion]="promotion"
        [ngClass]="promotion.active ? 'grid' : 'hidden'"
        class="grid-item grid-4 grid-md-6 grid-xs-12"
        [attr.data-testid]="'promotion-' + i"
      ></app-shared-promotion>
    </div>
  </div>
  <div class="grid-item">
    <div
      *ngIf="promotionsList && promotionsOnPage < promotionsList.length"
      class="button button-subtle button-bordered full-width"
      (click)="showMore()"
    >
      Показать ещё ↓
    </div>
  </div>
</div>
